/*
 * Admin area to edit survey rating labels.  Each set of labels is shown in a list broken down by language.
 */

define([
  "marionette",
  "messaging/messenger",
  "./surveyLabelsView",
  "./touchPointSelectDisplay/touchPointSelectModule",
  "./surveyLabelDisplay/surveyLabelDisplayModule",
  "./surveyLabelsModel",
], function (
  Marionette,
  Messenger,
  SurveyLabelsView,
  TouchPointSelectModule,
  SurveyLabelDisplayModule,
) {
  var SurveyLabelsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "surveyLabels";
      this.region = options.region;
      this.kb = options.model;
      this._setUpVents();
    },
    show: function () {
      this.layout = new SurveyLabelsView.surveyLabelsLayout();
      //set up submodules for touchPoint select and survey label list
      this.touchPointSelectModule = this.addSubModule(
        new TouchPointSelectModule({ region: this.layout.touchPointSelect }),
      );
      this.surveyLabelDisplayModule = this.addSubModule(
        new SurveyLabelDisplayModule({ region: this.layout.surveyLabelDisplay, model: this.kb }),
      );

      this.defaultTouchPoint = Messenger.reqres.request("default:touchpoint");
      this.touchPoints = this.kb.getTouchPoints();

      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      this.surveyLabelDisplayModule.show(this.defaultTouchPoint);
      this.touchPoints.onSynced(function () {
        this.touchPointSelectModule.show(this.touchPoints, this.defaultTouchPoint);
      }, this);
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:kb:admin:surveyLabels",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:surveyLabels",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "refresh:kb:response:settings",
        function (updatedKb) {
          this.kb = updatedKb;
        },
        this,
      );
    },
  });

  return SurveyLabelsController;
});
